import subtitle from 'text!./templates/Subtitle.html';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: subtitle,
        scope: {},
        link: function link($scope, $element, $attrs) {
            if ('offset' in $attrs) {
                $scope.hasOffset = true;
            }
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/titles/Subtitle.js
// module id = 2047
// module chunks = 0